import styled from 'styled-components'
import { H6, Small, H4 } from '@components/Text'
import getBreakpoint from '@client/utils/breakpoints'
import LoadingButton from '@components/LoadingButton'

export const FormWrapper = styled.form`
  & .MuiFormControl-root {
    margin-bottom: 16px;
    @media (min-width: ${getBreakpoint('md')}px) {
      margin-bottom: 24px;
    }
  }
  & .dynamic-text-block-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    p {
      margin: 0 0 16px;
      font-family: Rubik;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #41414a;
      align-self: center;
      @media (min-width: ${getBreakpoint('xl')}px) {
        margin-top: -16px;
      }
    }
  }
`

export const FormTitle = styled(H4)`
  font-weight: 900;
  line-height: 23px;
  margin-bottom: 10px;
  font-family: Rubik;
  enum {
    font-weight: 400;
    margin-right: 4px;
  }
`

export const FormSubtitle = styled(H6)`
  font-size: 14px;
  -webkit-letter-spacing: 0.5px;
  -moz-letter-spacing: 0.5px;
  -ms-letter-spacing: 0.5px;
  letter-spacing: 0.5px;
  font-style: normal;
  font-weight: normal;
  margin-bottom: 32px;
  font-family: Rubik;
`

export const Fieldset = styled.fieldset`
  margin-top: 30px;
  padding: 0;
  border: 0;
`

export const ButtonWrapper = styled.section`
  margin-top: 42px;
  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: 54px;
  }
`

export const ButtonText = styled(H6)`
  font-weight: 700;
  font-family: Rubik;
`

export const PrivacyPolicy = styled(Small)`
  margin-top: 32px;
  font-family: Rubik;
  a {
    font-weight: 700;
    text-decoration: none;
    color: #d8385e;
  }
  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: 8px;
  }
`

export const Button = styled(LoadingButton)`
  background: #231b22;
  border: 2px solid #231b22;

  &:hover {
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:focus {
    opacity: 0.75;
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:active {
    opacity: 0.75;
    background: #231b22;
  }
`
